import { getStudentValidation } from "../api/StudentDetails";

const validateUser = async (field: string, value: string): Promise<boolean> => {
  const res = await getStudentValidation(field, value);
  return res.data > 0; // true = already exists
};
export default validateUser;
